export const COLUMN_ALARM_ID = 'id';
export const COLUMN_REGISTERED_TIME = 'registeredTime';
export const COLUMN_ALARM_TIME = 'alarmTime';

export default {};
